import { text_mod_42 } from "../text/Text.js";

export const module42 = {
  title: "Створюю навчальний переказ розповідного змісту за поданим планом",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_42,
    },
  ],
};
